export default __webpack_public_path__ + "static/media/stake-banner.2df9f09b.png";